/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Underground_FloorsInputs */

const cs_form_underground_floors = /** @type {(inputs: Form_Underground_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podzemní podlaží`)
};

const en_form_underground_floors = /** @type {(inputs: Form_Underground_FloorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underground floors`)
};

/**
* | output |
* | --- |
* | "Underground floors" |
*
* @param {Form_Underground_FloorsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_underground_floors = /** @type {((inputs?: Form_Underground_FloorsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Underground_FloorsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_underground_floors(inputs)
	return cs_form_underground_floors(inputs)
});